(<template>
  <div id="app">
    <HeaderComponent />
    <div :class="contentClass">
      <router-view />
    </div>
  </div>
</template>

<script>
import HeaderComponent from './components/Header.vue';
import { authState } from './authState';

export default {
  name: 'App',
  components: {
    HeaderComponent,
  },
  data() {
    return { authState };
  },
  mounted() {
    document.title = 'incs TimeTracking'
  },
  computed: {
    contentClass() {
      if (this.$route.name === 'masterdata' || this.$route.name === 'admin' || this.$route.name === 'timeviewer') {
        return 'content no-center';
      } else {
        return 'content';
      }
    }
  }
}
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  cursor: default;
}

#app {
  font-family: "Lato", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #424242;
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.content {
  width: 80%;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
}

.no-center {
  margin: 6rem auto;
}

::-webkit-scrollbar {
  width: 0.5rem;
}

::-webkit-scrollbar-thumb {
  background: #c0c0c0;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: #4d4d4d;
}

.table {
  border-collapse: collapse;
  width: 100%;
}

.table td {
  padding: 8px;
}

.table th {
  background-color: #4D4D4D;
  color: white;
  text-align: left;
  padding: 8px;
}

.table tr:nth-child(even) {
  background-color: #dddddd;
}

.table td.timeRed {
  color: red;
}

.table td.timeGreen {
  color: green;
}

.filter-container {
  display: flex;
  text-align: left;
  flex-wrap: wrap;
  align-content: center;
  column-gap: 200px;
}

.filter {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 0.5rem;
}

.filter>label{
  font-weight: 600;
}

.filter>select {
  padding: .5rem .75rem;
  border: 1px solid #4D4D4D;
  border-radius: 5px;
  background-color: white;
}

.filter>input{
  padding: .5rem .75rem;
  border: 1px solid #4D4D4D;
  border-radius: 5px;
  background-color: white;
}

.display-right {
  text-align: right;
}

.sub {
  position: relative;
  top: 0.3ex;
  font-size: 75%;
  font-weight: normal
}
</style>
)